export const otherToPathNameMap = {
    // Oss项目 - 法人主体认证审核
    uims1048: ({ businessKey }) => `/uims-oss/teamVerify/edit?id=${businessKey}`,
    // Oss项目 - 企业管理员审核
    uims1049: ({ businessKey }) => `/m/oss/companyAdminExamine/examine?id=${businessKey}&type=detail`,
    // Oss项目 - 财务管理员审核
    uims1050: ({ businessKey }) => `/m/oss/financeAdminExamine/examine?id=${businessKey}&type=detail`,
    // Oss项目 - 用户审核
    uims1051: ({ businessKey }) => `/m/oss/userVerify/userHandle?id=${businessKey}&type=detail`,
    // Oss项目 - 工商变更审核
    uims1052: ({ businessKey }) => `/uims-oss/teamVertifyChange/edit?id=${businessKey}`,
    ant1000: ({ processInstanceId }, taskUrl) => 
    // taskUrl 要从源头变更传参
    `${taskUrl}${processInstanceId}?fp=${localStorage.getItem('fp')}&ct=1`,
};
